"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchRequestToJSON = exports.SearchRequestFromJSONTyped = exports.SearchRequestFromJSON = exports.instanceOfSearchRequest = exports.SearchRequestCollectionEnum = void 0;
const runtime_1 = require("../runtime");
const FilterBySpec_1 = require("./FilterBySpec");
const IncludeFieldSpec_1 = require("./IncludeFieldSpec");
const SortBySpec_1 = require("./SortBySpec");
/**
* @export
* @enum {string}
*/
var SearchRequestCollectionEnum;
(function (SearchRequestCollectionEnum) {
    SearchRequestCollectionEnum["Accounts"] = "accounts";
    SearchRequestCollectionEnum["Appointments"] = "appointments";
    SearchRequestCollectionEnum["Contacts"] = "contacts";
    SearchRequestCollectionEnum["Invoices"] = "invoices";
    SearchRequestCollectionEnum["PackageInstances"] = "packageInstances";
})(SearchRequestCollectionEnum || (exports.SearchRequestCollectionEnum = SearchRequestCollectionEnum = {}));
/**
 * Check if a given object implements the SearchRequest interface.
 */
function instanceOfSearchRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "organizationId" in value;
    isInstance = isInstance && "collection" in value;
    return isInstance;
}
exports.instanceOfSearchRequest = instanceOfSearchRequest;
function SearchRequestFromJSON(json) {
    return SearchRequestFromJSONTyped(json, false);
}
exports.SearchRequestFromJSON = SearchRequestFromJSON;
function SearchRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'organizationId': json['organizationId'],
        'collection': json['collection'],
        'query': !(0, runtime_1.exists)(json, 'query') ? undefined : json['query'],
        'queryBy': !(0, runtime_1.exists)(json, 'queryBy') ? undefined : json['queryBy'],
        'filterBy': !(0, runtime_1.exists)(json, 'filterBy') ? undefined : (json['filterBy'].map(FilterBySpec_1.FilterBySpecFromJSON)),
        'sortBy': !(0, runtime_1.exists)(json, 'sortBy') ? undefined : (json['sortBy'].map(SortBySpec_1.SortBySpecFromJSON)),
        'includeFields': !(0, runtime_1.exists)(json, 'includeFields') ? undefined : (json['includeFields'].map(IncludeFieldSpec_1.IncludeFieldSpecFromJSON)),
        'limit': !(0, runtime_1.exists)(json, 'limit') ? undefined : json['limit'],
        'offset': !(0, runtime_1.exists)(json, 'offset') ? undefined : json['offset'],
    };
}
exports.SearchRequestFromJSONTyped = SearchRequestFromJSONTyped;
function SearchRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'organizationId': value.organizationId,
        'collection': value.collection,
        'query': value.query,
        'queryBy': value.queryBy,
        'filterBy': value.filterBy === undefined ? undefined : (value.filterBy.map(FilterBySpec_1.FilterBySpecToJSON)),
        'sortBy': value.sortBy === undefined ? undefined : (value.sortBy.map(SortBySpec_1.SortBySpecToJSON)),
        'includeFields': value.includeFields === undefined ? undefined : (value.includeFields.map(IncludeFieldSpec_1.IncludeFieldSpecToJSON)),
        'limit': value.limit,
        'offset': value.offset,
    };
}
exports.SearchRequestToJSON = SearchRequestToJSON;
//# sourceMappingURL=SearchRequest.js.map